<template>
  <div class="comparison-gallery">
    <template v-for="compare in comparisons">
      <comparison-description
        :info="compare"
        :key="compare.compare_id + '-description'"
      />
      <comparison-card
        :key="compare.compare_id"
        :compare="compare"
        @removeCompare="removeCompare"
      />
    </template>
  </div>
</template>

<script>
  import ComparisonCard from './ComparisonCard'
  import ComparisonDescription from './ComparisonDescription'

  export default {
    name: 'ComparisonGallery',
    components: {
      ComparisonCard,
      ComparisonDescription,
    },
    props: {
      comparisons: {
        type: Array,
        required: true
      },
    },
    methods: {
      removeCompare(v) {
        this.$emit('removeCompare', v)
      }
    }
  }
</script>

<style lang="scss">
  .comparison-gallery {
    display: flex;
    flex-direction: column;
    gap: 36px;
    padding: 24px 20px;
  }
</style>
